import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-protection-donnees',
    templateUrl: './protection-donnees.component.html',
    styleUrls: ['./protection-donnees.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProtectionDonneesComponent { }
